import { render, staticRenderFns } from "./ArticleManage.vue?vue&type=template&id=27976ebb&scoped=true&"
import script from "./ArticleManage.vue?vue&type=script&lang=js&"
export * from "./ArticleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27976ebb",
  null
  
)

export default component.exports